import { createAction, props } from '@ngrx/store';

import { IGetReports } from '@hosty-app/types';

export const applyFilters = createAction(
  '[ReportsStore] Apply filters',
  props<{ payload: { filters: IGetReports } }>(),
);
